import { Box, SvgIconProps } from '@mui/material';
import { BenefitDTOBenefitEnum } from 'probonio-shared-ui/api';
import { ComponentType, useEffect } from 'react';
import { useRowSelectionState } from '../../component/table/useManualRowSelection';
import BenefitSubPage from '../../module/benefits/BenefitSubPage';
import { BulkActivationButton } from '../../module/benefits/bulkActivation/BulkActivationButton';
import { BulkBenefitActivationModalProvider } from '../../module/benefits/bulkActivation/BulkBenefitActivationModalProvider';
import { BulkEditActivationButton } from '../../module/benefits/bulkActivation/BulkEditActivationButton';
import { CouponsV2SepaAlert } from '../../module/benefits/couponsV2/CouponsV2SepaAlert';
import { BenefitEmployeeTabs } from '../../module/benefits/employeeStatusList/BenefitEmployeeTabs';
import { AdditionalEmployeeColumns } from '../../module/benefits/employeeStatusList/EmployeeBenefitStatusList';
import { useEmployeeFilterState } from '../../module/benefits/employeeStatusList/employeeFilterState';
import BenefitInfoText from './BenefitInfoText';

type EmployeesPageProps = {
  benefit: BenefitDTOBenefitEnum;
  icon: ComponentType<SvgIconProps>;
  title: string;
  subTitle: string;
  additionalColumns?: AdditionalEmployeeColumns;
};

export const EmployeesPage: React.FC<EmployeesPageProps> = ({ benefit, icon, title, subTitle, additionalColumns }) => {
  const filterState = useEmployeeFilterState();
  const rowSelectionState = useRowSelectionState();

  useEffect(() => {
    rowSelectionState.handleReset();
    // Intentionally excluding rowSelectionState from dependencies to avoid reset loops
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterState.filter.activationState]);

  return (
    <BulkBenefitActivationModalProvider rowSelectionState={rowSelectionState} employeeFilter={filterState.filter}>
      {benefit === BenefitDTOBenefitEnum.CouponsV2 && (
        <Box mt={0.5}>
          <CouponsV2SepaAlert />
        </Box>
      )}
      <BenefitSubPage
        icon={icon}
        title={title}
        subTitle={subTitle}
        menu={
          filterState.debouncedFilter.activationState === 'ACTIVE' ? (
            <BulkEditActivationButton rowSelectionState={rowSelectionState} />
          ) : (
            <BulkActivationButton rowSelectionState={rowSelectionState} />
          )
        }
      >
        <BenefitInfoText benefit={benefit} />
        <BenefitEmployeeTabs
          key={benefit}
          benefit={benefit}
          filterState={filterState}
          rowSelectionState={rowSelectionState}
          additionalColumns={additionalColumns}
        />
      </BenefitSubPage>
    </BulkBenefitActivationModalProvider>
  );
};
